import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_SAVE_CUSTOM_FIELDS_SERVER } from '@/app/module/custom-fields/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useCreateCustomFields = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [create, res] = esApi.endpoints.createOrgCustomfield.useMutation()

  const createCustomFields = useCallback(
    async (names: string[]) => {
      try {
        const result = await create({
          orgId: orgId.toString(),
          body: { names },
        }).unwrap()

        dispatch(
          createNotification({
            'create-custom-fields-success': {
              type: 'success',
              message: `Successfully created ${names.length} custom field${names.length > 1 ? 's' : ''}`,
            },
          }),
        )

        return result
      } catch {
        dispatch(
          createNotification({
            'create-custom-fields-failure': {
              type: 'error',
              message: ERROR_SAVE_CUSTOM_FIELDS_SERVER,
            },
          }),
        )

        return undefined
      }
    },
    [orgId, dispatch, create],
  )

  return [createCustomFields, res] as const
}
